import {Dropdown, Icon} from "semantic-ui-react"
import {FormattedMessage} from "react-intl"
import {i18nMessages} from "../locale"
import {useLocation} from "react-router"


type LanguageMenuProps = {
    onI18nLanguage: (lang: string) => void
}

export function I18nLanguageMenu({ onI18nLanguage }: LanguageMenuProps) {
    const i18nLanguages = Object.keys(i18nMessages).sort()
    const location = useLocation()

    const changeI18nLanguage = (i18nLanguage: string) => {
        onI18nLanguage(i18nLanguage)
        sessionStorage.setItem("i18nLanguage", i18nLanguage)
    }

    return (
        <>
            <Dropdown
                floating
                direction="left"
                className="item no-arrow i18n-menu"
                style={{ marginLeft: location.pathname === "/privacy" ? "auto" : 0 }}
                trigger={
                    <Icon className="i18n-icon" name="language"/>
                }>
                <Dropdown.Menu>
                {i18nLanguages.map(lang => (
                    <Dropdown.Item key={lang} onClick={() => changeI18nLanguage(lang)}>
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "50px" }}>
                            <div><FormattedMessage id={`i18n.language.${lang}`} defaultMessage={lang}/></div>
                            <div className="language-desc"><FormattedMessage id={`i18n.language.${lang}.local`} defaultMessage={lang}/></div>
                        </div>
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
        </>
    )
}